import { render, staticRenderFns } from "./Precipitation.vue?vue&type=template&id=f678c1d6&"
import script from "./Precipitation.vue?vue&type=script&lang=js&"
export * from "./Precipitation.vue?vue&type=script&lang=js&"
import style0 from "./Precipitation.vue?vue&type=style&index=0&id=f678c1d6&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports